module.exports = __webpack_public_path__ + "img/113639.0de04efb.svg";